import { PACKAGE_COLOR_SLOTS } from "@shared/constants";

/**
 * The package series ramp from docs/09-theme.md, as CSS custom properties so
 * both themes resolve it themselves rather than the code picking a hex per theme.
 *
 * One function, because a package's swatch in the editor, its bars in the charts
 * and its row in the table have to be the same colour or the colour
 * carries no information at all.
 */

export const packageColorVar = (colorIndex: number): string =>
  `var(--pkg-${(((colorIndex % PACKAGE_COLOR_SLOTS) + PACKAGE_COLOR_SLOTS) % PACKAGE_COLOR_SLOTS) + 1})`;

/** The slots a colour picker offers, in ramp order. */
export const PACKAGE_COLOR_INDEXES = Array.from({ length: PACKAGE_COLOR_SLOTS }, (_, i) => i);
